import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
import step2_1 from "@/assets/integration-steps/google-slim/step_2_1.png";
import step2_2 from "@/assets/integration-steps/google-slim/step_2_2.png";
import step2a_1 from "@/assets/integration-steps/google-slim/step_2a_1.png";
import step2a_2 from "@/assets/integration-steps/google-slim/step_2a_2.png";
import step2a_3 from "@/assets/integration-steps/google-slim/step_2a_3.png";
import step2a_4 from "@/assets/integration-steps/google-slim/step_2a_4.png";
import step2a_5 from "@/assets/integration-steps/google-slim/step_2a_5.png";
import step2b_1 from "@/assets/integration-steps/google-slim/step_2b_1.png";
import step2b_2 from "@/assets/integration-steps/google-slim/step_2b_2.png";
import step2b_3 from "@/assets/integration-steps/google-slim/step_2b_3.png";
import step2b_4 from "@/assets/integration-steps/google-slim/step_2b_4.png";
import step2b_5 from "@/assets/integration-steps/google-slim/step_2b_5.png";

interface Props {
  stepLabel?: string;
}

const GoogleSlimIntegrationStep2 = ({ stepLabel }: Props) => (
  <div className="channels-integration-step google-slim-step-2">
    <div className="step-label-row">
      {stepLabel && <OpticksNumberCircle number={stepLabel} />}
      <h6>Configure Opticks Audience in your campaigns</h6>
    </div>
    <div className="step-label-row">
      <p>
        It might take up to 48-72 hours to see the Opticks Audience populated.
      </p>
    </div>
    <p>
      You can see the size and availability of the audience in the Audience
      Manager of your Google Ads account (from the side menu: Tools {">"} Shared
      Library {">"} Audience Manager).
    </p>
   
    <img
      src={step2_1}
      alt="Screenshot of Google Ads Audiences Integration Step 2.1"
    />
   
    <img
      src={step2_2}
      alt="Screenshot of Google Ads Audiences Integration Step 2.2"
    />
   
    <p>
      As soon as the audience is ready to use, you can exclude it in your
      Search, Shopping and Display and PMAX campaigns.
    </p>
   
    <hr />
   
    <h4>Excluding in Search and Display campaigns</h4>
   
    <p>
      In order to do so, browse to the Campaigns section in the side menu, and
      then go to your campaign (click on it in the campaigns table, or just use
      the selector at the top of the screen). Then click on the "Audiences"
      section on the left panel. Once there, at the bottom of the screen, you
      will see the "Exclusions" module.
    </p>
   
    <img
      src={step2a_1}
      alt="Screenshot of Google Ads Audiences Integration Step 2a.1"
    />
   
    <p>
      Click on "Edit exclusions" and select "Campaign". You will see the
      following screen:
    </p>
   
    <img
      src={step2a_2}
      alt="Screenshot of Google Ads Audiences Integration Step 2a.2"
    />
   
    <p>
      On the "Browse" tab, select "How they have interacted with your business
      (Your data segments)", select "Website visitors" and search for the
      "Opticks Audience (Invalid traffic)" audience. Note that you might have to
      scroll the list in order to see it. Select it and click the "Save" button
      at the bottom of the window.
    </p>
   
    <img
      src={step2a_3}
      alt="Screenshot of Google Ads Audiences Integration Step 2a.3"
    />
    <img
      src={step2a_4}
      alt="Screenshot of Google Ads Audiences Integration Step 2a.4"
    />
   
    <p>
      Then, back to the audiences screen, you can expand the table at the bottom
      of the page to review the Opticks Audience is now correctly excluded:
    </p>
   
    <img
      src={step2a_5}
      alt="Screenshot of Google Ads Audiences Integration Step 2a.5"
    />
   
    <p>
      You can learn more about how Audience exclusions work and its effects{" "}
      <OpticksLink
        href="https://support.google.com/google-ads/answer/2549058?hl=en"
        label="here"
      />
      .
    </p>
   
    <hr />
   
    <h4>Excluding in PMAX and Shopping campaigns</h4>
   
    <p>
      These campaign types do not support direct exclusion of audiences.
      Instead, we can add the audience with a negative weight, so effectively
      that traffic is excluded.
    </p>
    <p>
      Browse to your campaign "Settings" and then search for the "Value rules"
      section and click on "Create Google Ads Value Rule".
    </p>
   
    <img
      src={step2b_1}
      alt="Screenshot of Google Ads Audiences Integration Step 2b.1"
    />
    <img
      src={step2b_2}
      alt="Screenshot of Google Ads Audiences Integration Step 2b.2"
    />
   
    <p>
      In the "Primary Condition" dropdown, select "Audience segment" and select
      the "Opticks Audience (invalid traffic)" segment.
    </p>
   
    <img
      src={step2b_3}
      alt="Screenshot of Google Ads Audiences Integration Step 2b.3"
    />
   
    <p>
      Ignore the "Secondary condition" option and in the "Value adjustment"
      section, select "Multiply" and set 0.5 as the Value.
    </p>
   
    <img
      src={step2b_4}
      alt="Screenshot of Google Ads Audiences Integration Step 2b.4"
    />
   
    <p>
      Then click "Save" in both the Rule creation window and your campaign
      settings. After that, it should look like this:
    </p>
   
    <img
      src={step2b_5}
      alt="Screenshot of Google Ads Audiences Integration Step 2b.5"
    />
   
    <p>
      By following these steps, the Performance Max algorithm will start
      following Opticks signals to stay away from invalid users.
    </p>
  </div>
);

export default GoogleSlimIntegrationStep2;
